import { createI18n } from 'vue-i18n';
import uzLatn from '../locales/uz-Latn.json';
import uzCyrl from '../locales/uz-Cyrl.json';
import ru from '../locales/ru.json';
import en from '../locales/en.json';
import { uzLatnToCyrl } from '@muslab/engine';

export const LOCALES = ['uz-Latn', 'uz-Cyrl', 'ru', 'en'] as const;
export type Locale = (typeof LOCALES)[number];
export const LOCALE_NAMES: Record<Locale, string> = {
  'uz-Latn': "O'zbekcha",
  'uz-Cyrl': 'Ўзбекча',
  ru: 'Русский',
  en: 'English',
};

/** uz-Cyrl faylida yetishmagan kalitlar uz-Latn dan transliteratsiya qilinadi */
function fillCyrl(
  latn: Record<string, unknown>,
  cyrl: Record<string, unknown>,
): Record<string, unknown> {
  const out: Record<string, unknown> = { ...cyrl };
  for (const [k, v] of Object.entries(latn)) {
    if (typeof v === 'string') {
      if (typeof out[k] !== 'string') out[k] = uzLatnToCyrl(v);
    } else if (Array.isArray(v)) {
      const cy = Array.isArray(out[k]) ? (out[k] as unknown[]) : [];
      out[k] = v.map((item, i) =>
        typeof item === 'string'
          ? (typeof cy[i] === 'string' ? cy[i] : uzLatnToCyrl(item))
          : fillCyrl(item as Record<string, unknown>, (cy[i] as Record<string, unknown>) ?? {}),
      );
    } else if (v && typeof v === 'object') {
      out[k] = fillCyrl(v as Record<string, unknown>, (out[k] as Record<string, unknown>) ?? {});
    }
  }
  return out;
}

function detectLocale(): Locale {
  try {
    const saved = localStorage.getItem('muslab.locale');
    if (saved && (LOCALES as readonly string[]).includes(saved)) return saved as Locale;
  } catch {
    /* ignore */
  }
  return 'uz-Latn';
}

export const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'uz-Latn',
  messages: {
    'uz-Latn': uzLatn,
    'uz-Cyrl': fillCyrl(uzLatn as Record<string, unknown>, uzCyrl as Record<string, unknown>),
    ru,
    en,
  } as never,
});

export function setLocale(l: Locale): void {
  i18n.global.locale.value = l;
  try {
    localStorage.setItem('muslab.locale', l);
  } catch {
    /* ignore */
  }
  document.documentElement.lang = l.startsWith('uz') ? 'uz' : l;
}
